<template>
  <transition name="toast-slide">
    <div v-if="visible" class="toast" :class="[`toast-${type}`]">
      <span class="toast-icon">{{ icon }}</span>
      <span class="toast-message">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseToast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['success', 'error', 'warning', 'info'].includes(value)
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    icon() {
      const icons = {
        success: '✓',
        error: '✕',
        warning: '⚠',
        info: 'ℹ'
      }
      return icons[this.type] || icons.info
    }
  },
  watch: {
    visible(val) {
      if (val && this.duration > 0) {
        setTimeout(() => {
          this.$emit('close')
        }, this.duration)
      }
    }
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.toast-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}

.toast-message {
  font-size: 14px;
  color: #333;
}

/* Types */
.toast-success {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
}

.toast-success .toast-icon {
  background: #67c23a;
}

.toast-error {
  background: #fef0f0;
  border: 1px solid #fde2e2;
}

.toast-error .toast-icon {
  background: #f56c6c;
}

.toast-warning {
  background: #fdf6ec;
  border: 1px solid #faecd8;
}

.toast-warning .toast-icon {
  background: #e6a23c;
}

.toast-info {
  background: #f4f4f5;
  border: 1px solid #e9e9eb;
}

.toast-info .toast-icon {
  background: #909399;
}

/* Transition */
.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.3s ease;
}

.toast-slide-enter,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}
</style>
